export default "__VITE_ASSET__D$BeK$iv__"